// Pure helpers for Marketing > Abandoned trade forms: the status vocabulary,
// the "last email sent" label and the CSV. The page handles fetch + render.

import { safeCsvCell, csvTimestamp } from '../../utils/csv.js'

export const STATUS_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'open', label: 'Open' },
  { value: 'finished', label: 'Chase finished' },
  { value: 'converted', label: 'Converted' },
  { value: 'unsubscribed', label: 'Unsubscribed' },
]

const STATUS_LABELS = Object.fromEntries(STATUS_OPTIONS.map(o => [o.value, o.label]))

const CSV_HEADERS = [
  'Name', 'Email', 'Captured', 'Source page', 'Status', 'Last email', 'Last email sent', 'Converted reference',
]

//: D1 writes "YYYY-MM-DD HH:MM:SS" in UTC with no zone. Read bare, JavaScript
//: takes it as local time and a BST reader sees every send an hour early.
const D1_TIMESTAMP = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/

export function statusLabel(status) {
  return STATUS_LABELS[status] || status || ''
}

/**
 * Has the chase sent this capture anything? Step 0, the same-evening email, is
 * a real send, so this tests for null and never for truthiness.
 */
export function hasLastEmail(row) {
  return row.last_step_sent !== null && row.last_step_sent !== undefined
}

/** "TS-0" to "TS-4", or '' when nothing has been sent. */
export function lastEmailLabel(row) {
  return hasLastEmail(row) ? `TS-${row.last_step_sent}` : ''
}

/** A D1 UTC timestamp as ISO, so every date formatter reads it as UTC. */
export function d1ToIso(value) {
  if (!value) return null
  return D1_TIMESTAMP.test(value) ? `${value.replace(' ', 'T')}Z` : value
}

export function buildAbandonedTradeFormsCsv(rows) {
  const lines = [CSV_HEADERS.join(',')]
  for (const row of rows || []) {
    lines.push([
      row.contact_name,
      row.contact_email,
      csvTimestamp(row.captured_at),
      row.source_page,
      statusLabel(row.status),
      lastEmailLabel(row),
      csvTimestamp(d1ToIso(row.last_sent_at)),
      row.converted_reference_code,
    ].map(safeCsvCell).join(','))
  }
  return lines.join('\n')
}
